<template>
  <div>
    <Title title="Importar Archivo"
           subtitle="Carga tus subordenes a partir de un archivo"/>
    <el-upload  class="upload-box"
                v-loading="loading"
                ref="upload"
                :fileList="files"
                :action="baseUrl"
                :auto-upload="false"
                :multiple="false"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :on-success="afterUploadSuccess"
                :on-error="afterUploadError"
                :headers="uploadHeader"
                drag>
      <div class="box-draw_drop-container">
        <p style="color: white; font-size: 25px; margin-top: 0; padding-top: 50px;">
          ARRASTRA TU ARCHIVO O HAZ CLIC</p>
        <div slot="tip" class="el-upload__tip">SÓLO ARCHIVOS <strong>.XLSX</strong>
          / MÁXIMO 1MB</div>
        <i style="color: white" class="fas fa-hand-pointer"></i>
      </div>
    </el-upload>
    <div class="upload-confirmation">
      <div v-if="hasFiles">
        <el-button  class="btn primary upload-button"
                    size="medium"
                    @click="handleUpload">
                    SUBIR ARCHIVO
        </el-button>
      </div>
      <div v-if="files.length === 0 && tableData.length > 0" class="table-container">
        <h3>Filas con problemas</h3>
        <el-table
          :data="tableData" style="width: 100%" height="250px" class="suborders-error">
          <el-table-column
            minWidth="120"
            label="Fila en xlsx"
            align="center">
            <template slot-scope="scope">
              {{scope.row.rownum}}
            </template>
          </el-table-column>
          <el-table-column
            minWidth="120"
            label="Suborder"
            align="center">
            <template slot-scope="scope">
              {{scope.row.code}}
            </template>
          </el-table-column>
          <el-table-column
            minWidth="160"
            label="Error"
            align="left">
            <template slot-scope="scope">
              {{scope.row.error}}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>

import { tenantCode } from '@/mixins/tenants';
import {
  getRumDuration,
  startRumTiming,
  trackBusinessFlow,
} from '@/observability/datadogRum';
import Title from '../components/base/Title.vue';

export default {
  name: 'Import',
  components: {
    Title,
  },
  data() {
    return {
      errorLoad: false,
      succLoad: false,
      hasFiles: false,
      hasError: false,
      tableData: [],
      file: {},
      files: [],
      loading: false,
      // baseUrl: `${process.env.VUE_APP_BASE_API_URL || 'https://uat.geosort.falabella.com/api/'}geocoding-service/v1/web/uploading`,
      baseUrl: `${process.env.VUE_APP_BASE_API_URL || 'https://geosort.falabella.com/api/'}geocoding-service/v1/web/uploading`,
      uploadHeader: {
        Authorization: `Bearer ${sessionStorage.token}`,
        'X-Country': tenantCode(),
      },
      uploadStartedAt: null,
    };
  },
  methods: {
    handleRemove() {
      this.hasFiles = false;
      trackBusinessFlow({
        module: 'import',
        flow: 'xlsx_import',
        action: 'file_removed',
        status: 'success',
      });
    },
    handleUpload() {
      this.loading = true;
      this.hasFiles = false;
      this.uploadStartedAt = startRumTiming();
      trackBusinessFlow({
        module: 'import',
        flow: 'xlsx_import',
        action: 'upload_requested',
        status: 'attempt',
        context: {
          file_name: this.file.name,
        },
      });
      this.$refs.upload.submit();
    },
    afterUploadSuccess(response) {
      this.files.pop();
      if (response.not_loaded) this.tableData = response.not_loaded.filter(d => d.code !== '');
      this.$notify({
        title: 'Completado',
        message: 'Puntos importados con exito.',
        type: 'success',
      });
      this.hasFiles = false;
      // this.$router.push({ name: 'Geocode' });
      this.loading = false;
      this.succLoad = true;
      trackBusinessFlow({
        module: 'import',
        flow: 'xlsx_import',
        action: 'upload_completed',
        status: 'success',
        durationMs: getRumDuration(this.uploadStartedAt),
        context: {
          invalid_rows: this.tableData.length,
        },
      });
    },
    // TODO: Mensajes de error
    afterUploadError() {
      this.files.pop();
      this.$notify.error({
        title: 'Error',
        message: 'Error al cargar archivo',
      });
      this.loading = false;
      this.errorLoad = true;
      trackBusinessFlow({
        module: 'import',
        flow: 'xlsx_import',
        action: 'upload_completed',
        status: 'error',
        durationMs: getRumDuration(this.uploadStartedAt),
      });
    },
    handleChange(file) {
      if (file.name.split('.')[1] !== 'xlsx') {
        trackBusinessFlow({
          module: 'import',
          flow: 'xlsx_import',
          action: 'file_selected',
          status: 'invalid',
          context: {
            file_name: file.name,
          },
        });
        this.$notify.error({
          title: 'Error',
          message: 'El archivo no cumple con formato .xlsx',
        });
        this.files = [];
      } else {
        trackBusinessFlow({
          module: 'import',
          flow: 'xlsx_import',
          action: 'file_selected',
          status: 'success',
          context: {
            file_name: file.name,
          },
        });
        if (!this.file && this.hasFiles) {
          this.hasFiles = false;
        } else {
          this.hasFiles = true;
          this.file = file;
        }
        if (!this.errorLoad) {
          this.hasFiles = true;
        } else {
          this.hasFiles = false;
          this.errorLoad = false;
        }
        if (this.succLoad) {
          this.hasFiles = false;
          this.succLoad = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
i {
  animation-duration: 2s;
  animation-name: slidein;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes slidein {
  from {
    margin-button: 50%;
    width: 100%;
  }
  to {
    margin-top: 0%;
    width: 100%;
  }
}
.upload-button {
  height: 45px;
  width: 150px;
  margin-top: 60px;
}
</style>

<style lang="scss">
.upload-box {
  width: 100%;
  height: 400px;
}
.upload-box .el-upload {
  width: 100%;
  height: 400px;
  z-index: -1;
}
.upload-box .el-upload-dragger {
  border: 0;
  z-index: -1;
  width: 100%;
  height: 400px;
  background-color: $fb-green;
}
.upload-box .box-draw_drop-container { margin-top: 60px; }
.upload-box .el-upload__text {
  color: white;
  font-size: 59px;
  font-weight: bold;
}
.upload-box .el-upload__tip {
  color: white;
  font-size: 13px;
  margin-top: 5px;
  font-weight: bold;
  margin-bottom: 30px;
}
.upload-box .el-upload-list {
  width: 30%;
  margin-left: 35%;
}
.upload-box .el-upload-list__item {
  color: white;
  font-size: 20px;
  margin-top: 40px;
}
.el-upload-list__item-name{ font-size: 13px; }
.suborders-error{ padding-top: 10px; }
.table-container{
  padding-left: 50px;
  padding-right: 50px;
}
.upload-box .fa-hand-pointer{
  font-size: 60px;
  margin-top: 30px;
}
</style>
